import { render } from "./InfoText.vue?vue&type=template&id=6bc6a96c&scoped=true"
import script from "./InfoText.vue?vue&type=script&lang=js"
export * from "./InfoText.vue?vue&type=script&lang=js"

import "./InfoText.vue?vue&type=style&index=0&id=6bc6a96c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adewale\\OneDrive - kochind.com\\Documents\\zoloscan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc6a96c"]])

export default __exports__